import { Command } from "commander";
import { screenshot } from "./screenshot.js";
import { snapshot } from "./snapshot.js";
import { start } from "./start.js";
import { status } from "./status.js";
import { stop } from "./stop.js";

export const browser = new Command()
  .name("browser")
  .description(
    "Control a long-running headless browser session for snapshots and screenshots. The session persists across invocations until you run `react-stack browser stop`.",
  );

browser.addCommand(start);
browser.addCommand(stop);
browser.addCommand(status);
browser.addCommand(snapshot);
browser.addCommand(screenshot);
